import { useMatches } from 'react-router-dom';

export type RouteHandle = {
	title: string;
	subTitle: string;
	isGoBack?: boolean;
};

type RouteHandleMode = 'merged' | 'current' | 'parent';

/**
 * Route handle 메타데이터를 가져오는 훅
 *
 * @param mode
 * - merged: 모든 라우트 병합 (기본값)
 * - current: 현재 라우트만
 * - parent: 부모 라우트만
 */
export const useRouteHandler = (mode: RouteHandleMode = 'merged'): RouteHandle => {
	const matches = useMatches();

	switch (mode) {
		case 'current': {
			const currentMatch = matches[matches.length - 1];
			return (currentMatch?.handle as RouteHandle) || ({} as RouteHandle);
		}
		case 'parent': {
			const parentMatch = matches[matches.length - 2];
			return (parentMatch?.handle as RouteHandle) || ({} as RouteHandle);
		}
		case 'merged':
		default:
			return matches.reduce((acc, match) => {
				const handle = (match.handle as RouteHandle) || {};
				if (!handle) return acc;
				return { ...acc, ...handle };
			}, {} as RouteHandle);
	}
};
